import React from 'react'

import { Skeleton } from 'components'

const imageRow = [
  {
    width: '70px',
    height: '70px',
    borderRadius: '6px',
  },
  {
    width: '70px',
    height: '70px',
    borderRadius: '6px',
  },
  {
    width: '70px',
    height: '70px',
    borderRadius: '6px',
  },
  {
    width: '70px',
    height: '70px',
    borderRadius: '6px',
  },
]

export const SkeletonPreviewImage: React.FC = () => {
  const base = 'f-stock-keeping-unit-preview-image'

  return (
    <div className={base}>
      <div className={`${base}__product-image-header`}>
        <div className={`${base}__product-image-label`}>
          <Skeleton.whiteSkeleton width='74px' />
        </div>
        <div className={`${base}__product-image-count-label`}>
          <Skeleton.whiteSkeleton width='56px' />
        </div>
      </div>
      <div className={`${base}__image-thumbnail`}>
        <Skeleton.whiteSkeleton
          width='325px'
          height='244px'
          borderRadius='8px'
        />
      </div>
      <div className={`${base}__skeleton-image-row`}>
        {imageRow.map((data, index) => {
          return (
            <div className={`${base}__image-row`} key={index}>
              <Skeleton.whiteSkeleton
                width={data.width}
                height={data.height}
                borderRadius={data.borderRadius}
              />
            </div>
          )
        })}
      </div>
    </div>
  )
}

export default SkeletonPreviewImage
